import { SearchResultComponentInfo } from './SearchResultComponentInfo';
import { SearchResultSystemInfo } from './SearchResultSystemInfo';

export * from './SearchResultComponentInfoCustomView';
export * from './SearchResultSystemInfoCustomView';
export const CustomViews = {
  SearchResultSystemInfo,
  SearchResultComponentInfo,
};
